module.exports = __webpack_public_path__ + "static/img/fabrication_5.79e93e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrication_5.jpg
// module id = k9tC
// module chunks = 0